/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statistics_Day_6Inputs */

const he_statistics_day_6 = /** @type {(inputs: Statistics_Day_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שבת`)
};

const en_statistics_day_6 = /** @type {(inputs: Statistics_Day_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saturday`)
};

/**
* | output |
* | --- |
* | "Saturday" |
*
* @param {Statistics_Day_6Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const statistics_day_6 = /** @type {((inputs?: Statistics_Day_6Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statistics_Day_6Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_statistics_day_6(inputs)
	return en_statistics_day_6(inputs)
});